import { render, staticRenderFns } from "./BarcodeScanner.vue?vue&type=template&id=0ff3107b&scoped=true"
import script from "./BarcodeScanner.vue?vue&type=script&lang=js"
export * from "./BarcodeScanner.vue?vue&type=script&lang=js"
import style0 from "./BarcodeScanner.vue?vue&type=style&index=0&id=0ff3107b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff3107b",
  null
  
)

export default component.exports